import { AetherBenefitsModal, FluidContainer, Meta } from '@atlassian/mpac-primitives';
import { CompatibleProductName } from '@atlassian/mpac-types';
import { COMPATIBLE_PRODUCT_FILTER_VALUES } from '@atlassian/mpac-utils';
import React, { useEffect } from 'react';
import { EnterpriseAppsSection } from '../components/EnterpriseAppsSection';
import { Hero } from '../components/Hero';
import { Sections } from '../components/Sections';
import { HeroWrapper, SectionWrapper } from '../HomepageCommon.styles';
import { useHomepage } from '../hooks';
import { useHomepageAnalytics } from '../hooks/useHomepageAnalytics';
import { useProductPageTelemetry } from '../telemetry/useProductPageTelemetry';
export const ProductHomepageView = _ref => {
  let {
    productInfo,
    productId
  } = _ref;
  const {
    enterpriseAppsSectionData,
    isEnterpriseAppsSectionLoading,
    isEnterpriseAppsSectionLoadError,
    areSectionsLoading,
    isSectionsLoadError,
    sectionsData,
    sectionsDataError,
    enterpriseAppsSectionDataError
  } = useHomepage({
    productId,
    shouldFetchEnterpriseApps: !!productInfo.showEnterpriseAppsSection
  });
  const {
    trackTileRenders
  } = useHomepageAnalytics();
  const {
    heading,
    description,
    breadcrumbTitle
  } = productInfo.banner;
  useProductPageTelemetry({
    productId,
    productInfo,
    isEnterpriseAppsSectionLoadError,
    enterpriseAppsSectionData,
    areSectionsLoading,
    isSectionsLoadError,
    sectionsData,
    sectionsDataError,
    enterpriseAppsSectionDataError
  });
  const productIdForAlgolia = COMPATIBLE_PRODUCT_FILTER_VALUES[productId];
  const productName = CompatibleProductName[productId];
  useEffect(() => {
    if (!areSectionsLoading) {
      trackTileRenders(enterpriseAppsSectionData, sectionsData);
    }
  }, [enterpriseAppsSectionData, sectionsData]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AetherBenefitsModal, null), /*#__PURE__*/React.createElement(Meta, {
    description: description,
    title: heading
  }), /*#__PURE__*/React.createElement(HeroWrapper, null, /*#__PURE__*/React.createElement(Hero, {
    heading: heading,
    description: description,
    breadcrumbTitle: breadcrumbTitle,
    productIdForAlgolia: productIdForAlgolia,
    productName: productName
  })), /*#__PURE__*/React.createElement(FluidContainer, null, /*#__PURE__*/React.createElement(SectionWrapper, null, /*#__PURE__*/React.createElement(EnterpriseAppsSection, {
    isLoading: isEnterpriseAppsSectionLoading,
    isError: isEnterpriseAppsSectionLoadError,
    data: enterpriseAppsSectionData
  })), !isEnterpriseAppsSectionLoading && /*#__PURE__*/React.createElement(Sections, {
    isLoading: areSectionsLoading,
    isError: isSectionsLoadError,
    data: sectionsData
  })));
};